import { type Dispatch, type SetStateAction } from "react";

import { ContractTypeAwsPpa } from "@doitintl/cmp-models";

import { type ContractStateType } from "../../types";
import { ifProductWithoutEntity, isLooker, productAllowsNoEntity } from "../../utils";

export const validateGeneralStep = (
  state: ContractStateType,
  setState: Dispatch<SetStateAction<ContractStateType>>
): boolean => {
  const errors: Record<string, boolean> = {};

  if (!state.type) {
    errors.type = true;
  }
  if ("pointOfSale" in state && state.pointOfSale) {
    if (!state.entity && !ifProductWithoutEntity(state.type, state.pointOfSale) && !productAllowsNoEntity(state.type)) {
      errors.entity = true;
    }
  }

  if (!state.accountManager) {
    errors.accountManager = true;
  }

  if (isLooker(state)) {
    if (!state.lookerSalesProcess) {
      errors.lookerSalesProcess = true;
    }

    if (state.assets.length === 0 && !state.isEditForbidden) {
      errors.assets = true;
    }
  }

  if (state.type === ContractTypeAwsPpa && !state.subtype) {
    errors.subtype = true;
  }

  setState({ ...state, errors });

  return !Object.values(errors).some((error) => error);
};
